module.exports = __webpack_public_path__ + "img/eecfbf8.png";